// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/minimax-cn.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const MINIMAX_CN_MODELS: ModelCatalog<typeof values, "minimax-cn"> =
	flattenModelCatalog("minimax-cn", values);
